import { DECREMENT, INCREMENT } from "./actionTypes";

const initialState = [
	{
		id: 1,
		title: "Asus Vivobook X515MA",
		price: 35500,
		quantity: 20,
		cartQuantity: 0,
	},
	{
		id: 2,
		title: "Dell E1916HV 18.5 Inch",
		price: 9300,
		quantity: 35,
		cartQuantity: 0,
	},
	{
		id: 3,
		title: "Canon Eos 4000D 18MP",
		price: 36500,
		quantity: 72,
		cartQuantity: 0,
	},
];

const cartReducer = (state = initialState, action) => {
	const copied = [
		...state.map((item) => {
			return { ...item };
		}),
	];
	switch (action.type) {
		case INCREMENT:
			copied.forEach((item) => {
				if(item.id === action.payload.id) {
					item.quantity = item.quantity - 1;
					item.cartQuantity = item.cartQuantity + 1;
				}
			})

			return copied;
		case DECREMENT:
			copied.forEach((item) => {
				if(item.id === action.payload.id) {
					item.quantity = item.quantity + 1;
					item.cartQuantity = item.cartQuantity - 1;
				}
			})

			return copied;
		default:
			return state;
	}
};

export default cartReducer;
